import React from 'react'
import { Skeleton, Button, Form, Input, message, Select } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../BaseComponent'
import { SearchRequest }from '../../../services/api/interfaces/ApiRequest'

type AnnouncementProps = BaseFormComponentProps & {
  uuid?: string,
  data?: any,
  error: any | null,

  loading: boolean,
  history: any,

  loadAnnouncement: (args: SearchRequest) => void,

  dispatchCreate: (args: any) => Promise<any>,
  dispatchUpdate: (args: any) => Promise<any>
}

export default class AnnouncementForm extends FormComponent<AnnouncementProps> {

  state = {
    saving: false,
    loaded: false
  }

  componentDidMount() {
    const { uuid, loadAnnouncement } = this.props

    // Check permissions
    this.validateAccessPermissions()

    if (uuid) {
      loadAnnouncement({
        search: {
          uuid
        }
      })
    }
  }

  componentDidUpdate(prevProps: AnnouncementProps, prevState) {
    const wasLoading = prevProps.loading && !this.props.loading
    let newState = Object.assign({}, this.state)

    // Check permissions
    this.validateAccessPermissions()

    // We are loaded?
    if (!this.state.loaded) {
      // If our entity was loaded or if we are creating a new one, that's means that we are loaded :P
      if (wasLoading || !this.props.uuid) {
        newState.loaded = true
      } 
    } else {
      // We are saving
      if (this.state.saving && wasLoading) {
        // Add the new role name to url
        if (!this.props.uuid && this.props.data) {
          this.props.history.replace(`/admin/announcement/${this.props.data.uuid}`)
        }

        if (!this.props.error) {
          message.success('Announcement saved successfully!')
        } else {
          message.error('Failed to save announcement. Error: ' + this.props.error)
        }

        newState.saving = false
      }
    }

    // Update if changed
    if (newState.loaded !== this.state.loaded) {
      this.setState(newState)
    }
  }

  handleSave = (values: any) => {
    const { uuid, dispatchCreate, dispatchUpdate } = this.props

    let payload: any = {
        ...values
    }

    if (uuid) {
      payload = {
        ...payload,
        uuid
      }
      
      dispatchUpdate(payload)
      this.setState({
        saving: true
      })
    } else {
      dispatchCreate(payload)
      this.setState({
        saving: true
      })
    }
  }

  render() {
    const { uuid, data, loading } = this.props
    const { loaded } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    let values:any = {
      name: '',
      type_key: 'INFO',
      origin_key: 'GLOBAL',
      title: '',
      description: '',
      link: ''
    }

    if (uuid) {
      values = {
        ...data || {}
      }
    }

    const { TextArea } = Input;

    return (
      <Form
        name="announcement"
        initialValues={values}
        layout="vertical"
        onFinish={this.handleSave}
      >
        <Form.Item
          label="Type"
          name="type_key"
          rules={[
            {
              required: true,
              message: 'Please select the announcement type'
            }
          ]}
        >
          <Select>
            <Select.Option value="INFO">Info</Select.Option>
            <Select.Option value="SYSTEM_UPDATE">System Update</Select.Option>
            <Select.Option value="SYSTEM_MAINTENANCE">System Maintenance</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Origin"
          name="origin_key"
          rules={[
            {
              required: true,
              message: 'Please select the announcement origin'
            }
          ]}
        >
          <Select>
            <Select.Option value="GLOBAL">Global</Select.Option>
            <Select.Option value="DASHBOARD">Dashboard</Select.Option>
            <Select.Option value="ALL_PETS">All Pets</Select.Option>
            <Select.Option value="ADOPTIONS">Adoptions</Select.Option>
            <Select.Option value="VISITORS">Visitors</Select.Option>
            <Select.Option value="REPORTS">Reports</Select.Option>
            <Select.Option value="CONTACTS">Contacts</Select.Option>
            <Select.Option value="PAYMENTS">Payments</Select.Option>
            <Select.Option value="PET_PROFILE">Pet Profile</Select.Option>
            <Select.Option value="APPLICATION_DETAILS">Application Details</Select.Option>
            <Select.Option value="SETTINGS">Settings</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Title"
          name="title"
          rules={[
            {
              required: true,
              message: 'Please enter a title for the announcement'
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[
            {
              required: true,
              message: 'Please enter a description for the announcement'
            }
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Link"
          name="link"
        >
          <Input placeholder="https://example.com" />
        </Form.Item>
        
        <Form.Item style={{marginTop: 32}}>
          <Button type="primary" htmlType="submit" size="large" loading={loading} ref={(refs) => this.actionRefs.save = refs} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  }
}